module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup popup-researchGroupMember"
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [_c('div', {
    staticClass: "outer"
  }, [_c('span', {
    staticClass: "header_title"
  }, [_vm._v("课题组成员搜索")]), _vm._v(" "), _c('svg', {
    staticClass: "arrow_down close-popup",
    attrs: {
      "width": "6.5vw",
      "height": "6.5vw",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M127.947776 279.937024L486.395904 743.875584c0 0 25.55392 25.778176 51.207168 0 40.80640001-41.105408 358.449152-442.91072 358.449152-463.93753599-25.201664-25.35424-51.207168 0-51.207168-1e-8L512 692.31616l-332.845056-412.379136C179.154944 279.937024 153.14944 254.582784 127.947776 279.937024z",
      "fill": "#ffffff"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "block_input"
  }, [_c('div', {
    staticClass: "wrap",
    on: {
      "click": _vm.autofocus
    }
  }, [_c('label', {
    staticClass: "icon icon-search icon_2",
    attrs: {
      "for": "search"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.query),
      expression: "query",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "icon_2",
    attrs: {
      "type": "search",
      "id": "search",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "outer_3"
  }, _vm._l((_vm.filteredData), function(member, index) {
    return _c('div', {
      key: index,
      staticClass: "outer_attr"
    }, [_c('div', {
      staticClass: "group close-popup",
      on: {
        "click": function($event) {
          return _vm.updateChosenResearchMember(member)
        }
      }
    }, [_c('img', {
      staticClass: "avator",
      attrs: {
        "src": "/static/img/avator2.png"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "attr_name"
    }, [_vm._v(_vm._s(member.memberName))]), _vm._v(" "), _c('div', {
      staticClass: "block"
    })]), _vm._v(" "), _vm._m(0, true)])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70bc91b6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/User/MyResearchGroup/researchGroupComponents/ResearchGroupMemberBox.vue
// module id = 1674
// module chunks = 8